export const SETTING_REGISTER_FLOW = {
  PERSON_DESIGNATION: 0,
  PRIVILEGE_ROLE: 1,
};
